import { useCallback, useState } from "react";

export const useBulkSelection = (items) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedIndexes, setSelectedIndexes] = useState([]);
    const [lastClicked, setLastClicked] = useState(-1);

    const selectionRange = (lastClicked, index) => {
        const range = [];
        if (lastClicked === -1) {
            return [index];
        } else {
            const start = lastClicked < index ? lastClicked : index;
            const end = lastClicked < index ? index : lastClicked;
            for (let i = start; i <= end; i++) {
                range.push(i);
            }
            return range;
        }
    };

    const setSelected = (range) => {
        setSelectedItems(range.map((r) => items[r]));
        setSelectedIndexes(range);
    };

    const toggleSelectedItems = useCallback((e, index, checked)   => {
        const allSelections = [...selectedIndexes, index].sort((a, b) => a - b);
        const selectedRange = e.nativeEvent.shiftKey ? selectionRange(lastClicked, index) : [index];

        const toggleRange = checked ? [...new Set([...allSelections, ...selectedRange])] :
            allSelections.filter(selection => !selectedRange.includes(selection));
        setSelected(toggleRange);

        setLastClicked(index);
    }, [selectedIndexes, lastClicked]);

    const toggleAllItems = () =>
        (selectedItems.length > 0) ?
            setSelected([]) :
            setSelected(items.map((e, i) => i));


    return { selectedItems, toggleSelectedItems, toggleAllItems };
};
